import ReactLoading from 'react-loading';

const OverlayLoader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/90 backdrop-blur-xs transition-opacity duration-300">
        <ReactLoading
          type="spin"
          color="#8BC34A"
          height={36}
          width={36}
        />
    </div>
  );
};

export default OverlayLoader;